<template>
    <svg
        width="100%"
        height="auto"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_11246_15578)">
            <g clip-path="url(#clip1_11246_15578)">
                <path
                    d="M50.2656 68.1973V68.9884"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M50.2656 70.4514V71.2426"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M48.7422 69.72H49.5333"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M51 69.72H51.7884"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M55.3828 62.7815V64.231"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M55.3828 66.9163V68.3658"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M52.5898 65.5725H54.0367"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M56.7227 65.5723H58.1722"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M88.3203 66.6306V67.9311"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M88.3203 70.3425V71.6458"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M85.8164 69.137H87.1169"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M89.5273 69.137H90.8306"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M94.043 93.5222H99.2803V87.3691"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M99.2766 84.6761V83.259H88.6367V89.1005"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M99.6023 82.01H88.3203V83.259H99.6023V82.01Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M94.5926 75.2991H93.3327L90.9023 79.1654H97.0229L94.5926 75.2991Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M88.6367 88.418H99.2766"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M92.1055 83.259H95.6494C95.6494 83.8903 95.1373 84.4024 94.506 84.4024H93.2488C92.6175 84.4024 92.1055 83.8903 92.1055 83.259Z"
                    class="primary-fill" />
                <path
                    d="M92.1406 88.4177H95.6845C95.6845 89.049 95.1725 89.5611 94.5412 89.5611H93.284C92.6527 89.5611 92.1406 89.049 92.1406 88.4177Z"
                    class="primary-fill" />
                <path
                    d="M94.7886 79.1655H93.125V82.0104H94.7886V79.1655Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M83.6282 85.0042L96.4139 95.4625L72.1376 95.4625H71.1486H46.875L59.9019 84.8037"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M59.9019 84.8037L46.875 95.4625L96.4139 95.4625L83.6282 85.0042"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M48.3771 99.5916H47.0522C46.6241 99.5916 46.2773 99.9384 46.2773 100.366V107.449C46.2773 107.877 46.6241 108.224 47.0522 108.224H48.8838C49.3119 108.224 49.6587 107.877 49.6587 107.449C49.6587 107.021 50.0055 106.674 50.4336 106.674L92.7953 106.674C93.2233 106.674 93.5702 107.021 93.5702 107.449C93.5702 107.877 93.917 108.224 94.345 108.224H96.1739C96.602 108.224 96.9488 107.877 96.9488 107.449V100.366C96.9488 99.9384 96.602 99.5916 96.1739 99.5916L48.3771 99.5916Z"
                    class="primary-fill" />
                <path
                    d="M46.875 95.4622L96.4139 95.4622V99.8622L46.875 99.8622V98.0713"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M57.0625 87.1282V79.195C57.0625 75.3693 60.1621 72.2698 63.9878 72.2698H79.4341C83.2598 72.2698 86.3594 75.3693 86.3594 79.195V86.99"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M78.047 74.4644H65.0581C62.0289 74.4644 59.5742 76.7999 59.5742 79.6773"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M71.23 88.3529C71.23 88.3529 71.2381 88.3285 71.2408 88.315C71.2571 88.2581 71.2733 88.2012 71.2896 88.1443V88.1389C71.9967 85.4701 71.0295 82.4437 71.0295 82.4437C65.5375 80.9318 60.7662 82.3841 60.5766 82.4437C60.5738 82.4437 60.5711 82.4437 60.5711 82.4437C60.5522 82.5006 60.5332 82.5575 60.5169 82.6144C60.5142 82.6252 60.5088 82.636 60.5061 82.6496C60.4899 82.7011 60.4763 82.7498 60.4628 82.8013C60.4628 82.8067 60.46 82.8149 60.4573 82.8203C59.9155 84.7954 60.1783 86.9548 60.3923 88.0982C60.395 88.1172 60.4004 88.1361 60.4032 88.1524C60.4032 88.1578 60.4031 88.1632 60.4059 88.1687C60.4492 88.3908 60.4871 88.5697 60.5169 88.697C60.5251 88.7322 60.5332 88.7647 60.5413 88.7918C60.5603 88.8704 60.5711 88.911 60.5711 88.911C60.5738 88.911 60.5766 88.911 60.5793 88.911C60.5874 88.911 60.5982 88.9165 60.6064 88.9192C60.6064 88.9192 60.6091 88.9192 60.6118 88.9192C60.647 88.93 60.6822 88.9381 60.7174 88.949C60.7581 88.9598 60.7987 88.9706 60.8394 88.9815C60.8881 88.995 60.9396 89.0086 60.9884 89.0194C61.0263 89.0303 61.0642 89.0384 61.1022 89.0465C61.2864 89.0899 61.468 89.1332 61.6522 89.1711C61.6847 89.1766 61.7145 89.1847 61.747 89.1901C61.8039 89.201 61.8608 89.2118 61.915 89.2226C61.9448 89.228 61.9746 89.2335 62.0044 89.2389C62.1995 89.2741 62.3946 89.3066 62.5896 89.3337C62.614 89.3364 62.6384 89.3418 62.6628 89.3445C62.7224 89.3527 62.782 89.3608 62.8416 89.3689C62.8687 89.3716 62.8958 89.3743 62.9202 89.3798C63.118 89.4042 63.3158 89.4258 63.5136 89.4421C63.5352 89.4421 63.5596 89.4475 63.5813 89.4475C63.6409 89.4529 63.7005 89.4583 63.7601 89.4611C63.7872 89.4611 63.8143 89.4665 63.8414 89.4665C63.901 89.4719 63.9606 89.4746 64.0175 89.48C64.0311 89.48 64.0446 89.48 64.0582 89.48C64.1801 89.4881 64.2993 89.4936 64.4185 89.499C64.4429 89.499 64.4673 89.499 64.4917 89.5017C64.5486 89.5017 64.6055 89.5071 64.6596 89.5071C64.6894 89.5071 64.7165 89.5071 64.7463 89.5098C64.8032 89.5098 64.8574 89.5125 64.9143 89.5152C64.936 89.5152 64.9577 89.5152 64.9766 89.5152C65.0877 89.5152 65.2015 89.518 65.3099 89.5207C65.3316 89.5207 65.3532 89.5207 65.3722 89.5207C65.3939 89.5207 65.4129 89.5207 65.4345 89.5207C68.3119 89.5207 70.6637 88.9869 70.9861 88.911C70.9861 88.911 70.9861 88.911 70.9888 88.911C71.0024 88.9083 71.0132 88.9056 71.0186 88.9029H71.0213V88.8975C71.0511 88.8298 71.0809 88.7566 71.1053 88.6862C71.1243 88.632 71.1433 88.5778 71.1622 88.5263C71.1622 88.5182 71.1676 88.5101 71.1704 88.5046C71.1866 88.4504 71.2056 88.399 71.2218 88.3448L71.23 88.3529Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M78.695 81.7741C75.227 81.6278 72.6991 82.3973 72.5609 82.4379C72.5582 82.4379 72.5555 82.4379 72.5555 82.4379C72.5365 82.4948 72.5176 82.5517 72.5013 82.6086C72.4986 82.6194 72.4932 82.6303 72.4905 82.6438C72.4742 82.6953 72.4607 82.7441 72.4471 82.7955C72.4471 82.801 72.4444 82.8091 72.4417 82.8145C71.8998 84.7897 72.1626 86.9491 72.3767 88.0924C72.3794 88.1114 72.3848 88.1304 72.3875 88.1466C72.3875 88.152 72.3875 88.1575 72.3902 88.1629C72.4336 88.3851 72.4715 88.5639 72.5013 88.6912C72.5094 88.7264 72.5176 88.759 72.5257 88.786C72.5447 88.8646 72.5555 88.9053 72.5555 88.9053C72.5582 88.9053 72.5609 88.9053 72.5636 88.9053C72.5718 88.9053 72.5826 88.9107 72.5907 88.9134C72.5907 88.9134 72.5934 88.9134 72.5962 88.9134C72.6314 88.9242 72.6666 88.9324 72.7018 88.9432C72.7425 88.954 72.7831 88.9649 72.8237 88.9757C72.8725 88.9893 72.924 89.0028 72.9728 89.0136C73.0107 89.0245 73.0486 89.0326 73.0866 89.0407C73.2708 89.0841 73.4523 89.1274 73.6366 89.1654C73.6691 89.1708 73.6989 89.1789 73.7314 89.1843C73.7883 89.1952 73.8452 89.206 73.8994 89.2168C73.9292 89.2223 73.959 89.2277 73.9888 89.2331C74.1839 89.2683 74.3789 89.3008 74.574 89.3279C74.5984 89.3306 74.6228 89.3361 74.6472 89.3388C74.7068 89.3469 74.7664 89.355 74.826 89.3632C74.8531 89.3659 74.8802 89.3686 74.9046 89.374C75.1024 89.3984 75.3001 89.4201 75.4979 89.4363C75.5196 89.4363 75.544 89.4417 75.5657 89.4417C75.6253 89.4471 75.6849 89.4526 75.7445 89.4553C75.7716 89.4553 75.7987 89.4607 75.8258 89.4607C75.8854 89.4661 75.945 89.4688 76.0019 89.4742C76.0154 89.4742 76.029 89.4742 76.0425 89.4742C76.1644 89.4824 76.2837 89.4878 76.4029 89.4932C76.4273 89.4932 76.4516 89.4932 76.476 89.4959C76.5329 89.4959 76.5898 89.5013 76.644 89.5013C76.6738 89.5013 76.7009 89.5013 76.7307 89.504C76.7876 89.504 76.8418 89.5068 76.8987 89.5095C76.9204 89.5095 76.9421 89.5095 76.961 89.5095C77.0721 89.5095 77.1859 89.5122 77.2943 89.5149C77.3159 89.5149 77.3376 89.5149 77.3566 89.5149C77.3783 89.5149 77.3972 89.5149 77.4189 89.5149C80.2963 89.5149 82.6481 88.9811 82.9705 88.9053C82.9705 88.9053 82.9705 88.9053 82.9732 88.9053C82.9868 88.9025 82.9976 88.8998 83.003 88.8971H83.0057V88.8917C83.0355 88.824 83.0653 88.7508 83.0897 88.6804C83.1087 88.6262 83.1276 88.572 83.1466 88.5205C83.1466 88.5124 83.152 88.5043 83.1547 88.4988C83.171 88.4447 83.19 88.3932 83.2062 88.339C83.2089 88.3254 83.2143 88.3146 83.217 88.3011C83.2333 88.2442 83.2496 88.1873 83.2658 88.1304V88.1249C83.973 85.4562 83.0057 82.4298 83.0057 82.4298C82.3121 82.2401 81.6293 82.0965 80.9682 81.9908"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M77.387 55.9807H66.8555V68.4115H77.387V55.9807Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M73.7611 60.286C74.3626 60.286 74.8502 59.7984 74.8502 59.1968C74.8502 58.5953 74.3626 58.1077 73.7611 58.1077C73.1595 58.1077 72.6719 58.5953 72.6719 59.1968C72.6719 59.7984 73.1595 60.286 73.7611 60.286Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M66.9648 61.6405C67.374 61.3235 68.092 60.8575 69.0403 60.7627C71.029 60.5622 72.0504 62.1932 74.3046 62.326C74.9441 62.3639 75.952 62.2935 77.2362 61.6405"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M67.0391 63.2418C67.3994 63.4613 69.1334 64.4638 71.4717 64.0926C73.4414 63.781 74.6281 62.6837 74.9749 62.3396"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M69.6094 64.1199C70.2461 64.6726 71.235 65.3608 72.5681 65.6995C74.8927 66.2901 77.2553 65.5667 77.2472 65.499"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M48.9959 49.5027L96.6084 49.5027C101.236 49.5027 104.986 53.2525 104.986 57.8802L104.986 114.978L40.6211 114.978L40.6211 62.3372"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M87.4213 49.3564V28.7648C87.4213 20.7612 80.9322 14.2749 72.9313 14.2749C64.9304 14.2749 58.4414 20.7639 58.4414 28.7648L58.4414 35.2485"
                    class="accent-stroke"
                    stroke-width="3.95915"
                    stroke-miterlimit="10" />
                <path
                    d="M104.989 108.221L104.989 57.5171C104.989 53.0899 101.401 49.5027 96.9742 49.5027L48.6355 49.5027C44.2084 49.5027 40.6211 53.0899 40.6211 57.5171"
                    class="accent-stroke"
                    stroke-width="3.95915"
                    stroke-miterlimit="10" />
                <path
                    d="M104.79 65.0982C105.147 64.5834 105.044 63.8356 104.559 63.4319C104.074 63.0282 103.392 63.1176 103.034 63.6324C102.977 63.7164 102.931 63.8058 102.898 63.9007C103.272 63.6189 103.793 63.6243 104.183 63.9521C104.589 64.2908 104.727 64.8706 104.551 65.3529C104.641 65.2852 104.722 65.2012 104.792 65.1009L104.79 65.0982Z"
                    class="primary-stroke primary-fill"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M114.162 81.479L100.45 70.0345C100.309 69.9153 100.198 69.7581 100.133 69.5793L98.6858 65.6425C98.5638 65.3065 98.6072 64.9299 98.8023 64.6454L102.525 59.2754C102.487 59.3133 102.452 59.354 102.419 59.4L98.4229 65.1629C98.2279 65.4447 98.1845 65.824 98.3064 66.16L99.7533 70.0968C99.821 70.2756 99.9294 70.4328 100.07 70.552L113.783 81.9965C114.205 82.3487 114.799 82.2702 115.11 81.8204L115.381 81.4303C115.053 81.7608 114.539 81.7933 114.162 81.4763V81.479Z"
                    class="primary-stroke primary-fill"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M121.676 70.6336C122.099 70.9858 122.188 71.636 121.877 72.0831L115.485 81.3032C115.174 81.753 114.58 81.8316 114.158 81.4793L100.445 70.0348C100.304 69.9156 100.193 69.7584 100.128 69.5796L98.6814 65.6428C98.5595 65.3069 98.6029 64.9302 98.7979 64.6458L102.794 58.8828C102.989 58.6011 103.312 58.452 103.64 58.4927L107.482 58.9723C107.655 58.9939 107.823 59.0671 107.964 59.1863L121.676 70.6309V70.6336ZM103.26 65.2987C103.745 65.7024 104.428 65.613 104.786 65.0982C105.143 64.5834 105.04 63.8356 104.555 63.4319C104.07 63.0282 103.388 63.1177 103.03 63.6324C102.672 64.1472 102.775 64.895 103.26 65.2987Z"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M84.8458 46.0859C84.7537 46.8581 84.7049 48.2806 85.5313 49.768C87.7774 53.8023 93.7842 53.5097 99.1651 58.3108C100.774 59.7468 102.517 61.8059 103.944 64.8351"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M108.734 67.6561C108.709 67.228 108.866 66.8027 109.208 66.3854C109.549 65.9682 109.931 65.727 110.356 65.6647C110.782 65.6024 111.183 65.7243 111.565 66.0359C111.947 66.3475 112.147 66.716 112.172 67.144C112.196 67.5721 112.039 67.9975 111.698 68.4148C111.356 68.832 110.974 69.0731 110.549 69.1355C110.123 69.1978 109.72 69.0759 109.34 68.7643C108.958 68.4554 108.758 68.0842 108.734 67.6561ZM110.378 68.2224C110.565 68.1547 110.749 68.0111 110.931 67.7889C111.107 67.5721 111.21 67.3662 111.237 67.1684C111.264 66.9706 111.199 66.8081 111.042 66.6807C110.885 66.5534 110.711 66.5209 110.524 66.5886C110.338 66.6563 110.156 66.7972 109.98 67.0167C109.798 67.2389 109.693 67.4475 109.666 67.6453C109.638 67.8431 109.704 68.0056 109.861 68.1357C110.018 68.2657 110.191 68.2955 110.381 68.2278L110.378 68.2224ZM113.99 68.0111L114.808 68.6776L107.428 72.1673L106.609 71.5008L113.99 68.0111ZM109.265 73.0479C109.24 72.6198 109.397 72.1971 109.739 71.7771C110.08 71.3572 110.462 71.1188 110.888 71.0564C111.313 70.9941 111.714 71.116 112.096 71.4276C112.478 71.7392 112.678 72.1077 112.703 72.5358C112.727 72.9639 112.57 73.3892 112.229 73.8065C111.887 74.2237 111.505 74.4649 111.08 74.5272C110.655 74.5895 110.251 74.4676 109.872 74.156C109.489 73.8471 109.289 73.4759 109.265 73.0479ZM110.906 73.6141C111.093 73.5464 111.278 73.4001 111.459 73.1779C111.641 72.9557 111.738 72.7552 111.768 72.5574C111.795 72.3624 111.73 72.1971 111.573 72.0698C111.416 71.9424 111.242 71.9099 111.056 71.9776C110.869 72.0454 110.687 72.189 110.511 72.403C110.335 72.6171 110.226 72.8365 110.197 73.0316C110.167 73.2267 110.235 73.3919 110.392 73.5193C110.549 73.6466 110.722 73.6791 110.909 73.6114L110.906 73.6141Z"
                    class="primary-fill" />
                <path
                    d="M86.7408 42.1358V28.5833C86.7408 22.2433 81.6011 17.1035 75.261 17.1035C68.921 17.1035 63.7812 22.2433 63.7812 28.5833V33.7203"
                    class="primary-stroke"
                    stroke-width="0.692851"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
            </g>
            <path
                d="M17.4062 67.4776C17.4062 67.4776 17.9454 65.211 18.3564 65.5122C18.7675 65.8151 19.761 68.1433 19.1802 68.5427C18.5994 68.9421 17.3779 67.0898 20.1388 67.406C22.0559 67.6257 21.6598 67.9502 21.0474 68.4262C20.435 68.9021 16.882 72.1273 16.4776 71.5232C16.0732 70.9191 17.4311 69.6676 16.7222 69.1002C16.0133 68.5327 14.8933 68.1449 15.2294 67.6889C15.5107 67.3045 16.4376 67.4044 16.4376 67.4044"
                class="primary-stroke"
                stroke-width="0.582464"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M19.8437 69.4397C19.8437 69.4397 20.6076 71.2237 20.1699 71.5033C19.9552 71.6397 19.2979 71.232 19 71.0273"
                class="primary-stroke"
                stroke-width="0.582464"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M3.82801 49.8135C4.28531 49.8135 4.65602 49.4428 4.65602 48.9855C4.65602 48.5282 4.28531 48.1575 3.82801 48.1575C3.37071 48.1575 3 48.5282 3 48.9855C3 49.4428 3.37071 49.8135 3.82801 49.8135Z"
                class="primary-stroke"
                stroke-width="0.467391"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M41.2266 16.8262L41.2319 17.6972"
                class="primary-stroke"
                stroke-width="0.940919"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M41.2383 19.3127L41.2437 20.1838"
                class="primary-stroke"
                stroke-width="0.940919"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M39.5547 18.5117L40.4257 18.509"
                class="primary-stroke"
                stroke-width="0.940919"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                d="M42.0391 18.501L42.9101 18.4983"
                class="primary-stroke"
                stroke-width="0.940919"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <circle cx="31.2571" cy="43.701" r="21.7337" class="primary-fill" />
            <text
                v-if="text.length"
                x="30"
                y="30"
                text-anchor="middle"
                dominant-baseline="middle"
                class="text">
                <tspan v-for="(t, index) in text" :key="index" x="30" dy="1.2em">
                    {{ t }}
                </tspan>
            </text>
        </g>
        <defs>
            <clipPath id="clip0_11246_15578">
                <rect width="128" height="128" fill="white" />
            </clipPath>
            <clipPath id="clip1_11246_15578">
                <rect
                    width="113.576"
                    height="129"
                    fill="white"
                    transform="translate(11.1641)" />
            </clipPath>
        </defs>
    </svg>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    export default defineComponent({
        name: 'Join4',
        props: {
            text: { type: Array as PropType<string[]>, default: [] as string[] },
        },
    });
</script>

<style lang="scss" scoped>
    @use '@ui/styling/import.scss' as *;

    .text {
        fill: white;
        /*TODO: replace for Title Label Small*/
        font: var(--font-heading-6);
        font-size: 6px;
    }
</style>
